import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";

//MUI
import Grid from "@mui/material/Grid";
import { Box } from "@mui/system";
import Button from "@mui/material/Button";
import { Paper, TextField, Typography } from "@mui/material";

import { getMyInvoiceById, stopActiveInvoice } from "API/myPages";
import RegularModal from "Components/UI/Modals/RegularModal";
import { LoadingButton } from "@mui/lab";
import { usePopupNotificationContext } from "Context/NotificationPopup";
import { InvoiceView } from "Pages/AdminInterface/invoices/invoice/invoicecard/InvoiceView";
import EndcustomerAccountsTableContainer from "Components/Account/EndcustomerAccountTableContainer";
import { ArticlesContextProvider } from "Context/Articles";
import { ArrowBack } from "@mui/icons-material";

export function MyPageInvoiceCard() {
  const { invoiceID } = useParams();

  const [invoice, setInvoice] = useState(null);
  const [openStopInvoiceModal, setOpenStopInvoiceModal] = useState(false);
  const [stopInvoiceMsg, setStopInvoiceMsg] = useState("");
  const [stopInvoiceLoading, setStopInvoiceLoading] = useState(false);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const { openSuccess, openError } = usePopupNotificationContext();

  useEffect(() => {
    const asyncInitView = async () => {
      setLoading(true);
      try {
        const invoice = await getMyInvoiceById(invoiceID);

        if (invoice) {
          setInvoice(invoice);
        }
      } catch (err) {
        openError("Någonting gick fel vid hämtning av fakturor", 3000);
        console.error(err);
      } finally {
        setLoading(false);
      }
    };
    asyncInitView();
  }, [invoiceID]);

  const handleOnStopInvoice = async () => {
    setStopInvoiceLoading(true);
    try {
      await stopActiveInvoice({
        InvoiceId: invoice.Id,
        Comment: stopInvoiceMsg,
      });
      openSuccess("OK!");
    } catch (error) {
      setOpenStopInvoiceModal(false);
      openError(error.response.data, 3000);
    }
    setOpenStopInvoiceModal(false);
    setStopInvoiceLoading(false);
  };

  if (loading) {
    return null;
  }

  return (
    <Box display={"flex"} fullWidth justifyContent={"center"}>
      <Box
        display={"flex"}
        flexDirection={"column"}
        justifyContent={"center"}
        alignItems={"center"}
        maxWidth={"1400px"}
        fullWidth
        marginBottom={10}
        gap={6}
      >
        <Box>
          <Box
            width={"100%"}
            display={"flex"}
            justifyContent={"flex-start"}
            alignItems={"flex-end"}
          >
            <Button
              variant="text"
              startIcon={<ArrowBack />}
              onClick={() => navigate(-1)}
            >
              Tillbaka
            </Button>
          </Box>
          <InvoiceView
            invoice={invoice}
            setInvoice={() => {}}
            loading={loading}
            onUpdateInvoice={() => {}}
            setSelectedLogs={() => {}}
            isClientView={true}
          />
        </Box>
        <Paper sx={{ width: "100%" }}>
          <Typography
            top={30}
            paddingX={3}
            paddingTop={2}
            fontWeight={"medium"}
          >
            Fakturahändelser
          </Typography>
          <Box width={"100%"} borderRadius={2} overflow={"hidden"}>
            <ArticlesContextProvider>
              <EndcustomerAccountsTableContainer
                accounts={invoice?.EndCustomerAccounts}
              />
            </ArticlesContextProvider>
          </Box>
        </Paper>
      </Box>

      <RegularModal
        title={"Stoppa faktura"}
        open={openStopInvoiceModal}
        onClose={() => setOpenStopInvoiceModal(false)}
        style={{ minWidth: "30%" }}
      >
        <Grid item container spacing={2}>
          <Grid item>
            <TextField
              name="Message"
              label="Meddelande"
              value={stopInvoiceMsg}
              size="small"
              color="primary"
              fullWidth
              multiline
              minRows={4}
              margin="dense"
              onChange={(e) => setStopInvoiceMsg(e.target.value)}
            />
          </Grid>
          <Grid item container spacing={2}>
            <Grid item>
              <LoadingButton
                variant="contained"
                color="error"
                loading={stopInvoiceLoading}
                onClick={() => handleOnStopInvoice()}
              >
                Stoppa
              </LoadingButton>
            </Grid>
            <Grid item>
              <LoadingButton onClick={() => setOpenStopInvoiceModal(false)}>
                Avbryt
              </LoadingButton>
            </Grid>
          </Grid>
        </Grid>
      </RegularModal>
    </Box>
  );
}
